import { PaymentMethod } from "../enums/payment";
import { getDatePlusNDays } from "./dates";
export const isBankDebitPaymentMethod = (paymentMethod) => paymentMethod === PaymentMethod.Ach || paymentMethod === PaymentMethod.Pad || paymentMethod === PaymentMethod.Sepa;
export const BANK_DEBIT_REFUND_DELAY_IN_DAYS = 60;
export const isWithinBankDebitRefundDelay = ({ paymentMethod, createdAtUtc, currentUtc = new Date(), }) => isBankDebitPaymentMethod(paymentMethod) &&
    getDatePlusNDays(createdAtUtc, BANK_DEBIT_REFUND_DELAY_IN_DAYS).getTime() > currentUtc.getTime();
export const isAchPadAllowed = ({ currentUtc = new Date(), startUtc, endUtc, }) => {
    const hasMinimumDaysBeforeEvent = (days) => {
        const minDateRequired = getDatePlusNDays(currentUtc, days);
        return endUtc ? new Date(endUtc) >= minDateRequired : startUtc ? new Date(startUtc) >= minDateRequired : true;
    };
    return {
        isPadAllowed: hasMinimumDaysBeforeEvent(10),
        isAchAllowed: hasMinimumDaysBeforeEvent(10),
        isSepaAllowed: hasMinimumDaysBeforeEvent(10),
    };
};
